// Pure formatting helpers for the Data coverage report body.
// Every date is taken from the server response; nothing here reads the clock.

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function fmtMonth(ym) {
  if (typeof ym !== "string" || !/^\d{4}-\d{2}$/.test(ym)) return "Unavailable";
  const [y, m] = ym.split("-").map(Number);
  return `${MONTHS[m - 1]} ${y}`;
}

export function fmtShortMonth(ym) {
  if (typeof ym !== "string" || !/^\d{4}-\d{2}$/.test(ym)) return "—";
  return MONTHS[Number(ym.slice(5, 7)) - 1];
}

// YYYY-MM-DD date-only values are formatted without timezone conversion.
export function fmtDate(value) {
  if (!value) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value));
  if (!m) return null;
  return `${MONTHS[Number(m[2]) - 1]} ${Number(m[3])}, ${m[1]}`;
}

export function fmtDateTime(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return `${MONTHS[d.getUTCMonth()]} ${d.getUTCDate()}, ${d.getUTCFullYear()} ${String(d.getUTCHours()).padStart(2, "0")}:${String(d.getUTCMinutes()).padStart(2, "0")} UTC`;
}

export function fmtWeekday(value) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value ?? ""));
  if (!m) return "";
  return ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][new Date(Date.UTC(+m[1], +m[2] - 1, +m[3])).getUTCDay()];
}

// Relative age measured against the response asOf. Returns null when either
// side is unknown so callers render nothing rather than inventing an age.
export function relativeAge(iso, asOf) {
  if (!iso || !asOf) return null;
  const a = new Date(iso).getTime();
  const b = new Date(asOf).getTime();
  if (Number.isNaN(a) || Number.isNaN(b)) return null;
  const mins = Math.max(0, Math.round((b - a) / 60000));
  if (mins < 1) return "just before as-of";
  if (mins < 60) return `${mins} min before as-of`;
  const hrs = Math.round(mins / 60);
  if (hrs < 48) return `${hrs} h before as-of`;
  return `${Math.round(hrs / 24)} days before as-of`;
}

export function fmtRatio(r) {
  if (r === null || r === undefined || Number.isNaN(Number(r))) return "n/a";
  const pct = Number(r) * 100;
  return `${pct >= 99.95 || pct === 0 ? pct.toFixed(0) : pct.toFixed(1)}%`;
}

export function fmtCount(n) {
  if (n === null || n === undefined) return "—";
  return Number(n).toLocaleString("en-US");
}
